for (const rangeSlider of document.querySelectorAll('.range-slider')) {
    const inputs = rangeSlider.querySelectorAll('[type="range"]');
    const max = parseInt(inputs[0].max);
    let value_from = parseInt(inputs[0].value);
    let value_to = parseInt(inputs[1].value);
    let percentage_from = (value_from * 100) / max;
    let percentage_to = (value_to * 100) / max;
    inputs[0].addEventListener('input', function () {
        value_from = parseInt(inputs[0].value);
        if (value_from > value_to - 1) {
            value_from = inputs[0].value = value_to - 1;
        }
        rangeSlider.querySelector('.range-slider-data-from').innerText =
            value_from;
        percentage_from = (value_from * 100) / max;
        updateRangeSliderDom(rangeSlider, percentage_from, percentage_to);
    });
    inputs[1].addEventListener('input', function () {
        value_to = parseInt(inputs[1].value);
        if (value_to < value_from + 1) {
            value_to = inputs[1].value = value_from + 1;
        }
        rangeSlider.querySelector('.range-slider-data-to').innerText = value_to;
        percentage_to = (value_to * 100) / max;
        updateRangeSliderDom(rangeSlider, percentage_from, percentage_to);
    });
}

function updateRangeSliderDom(rangeSlider, percentage_from, percentage_to) {
    rangeSlider.querySelectorAll('.range-slider-thumb')[0].style.left =
        percentage_from + '%';
    rangeSlider.querySelectorAll('.range-slider-thumb')[1].style.left =
        percentage_to + '%';
    rangeSlider.querySelector('.range-slider-left').style.width =
        percentage_from + '%';
    rangeSlider.querySelector('.range-slider-middle').style.left =
        percentage_from + '%';
    rangeSlider.querySelector('.range-slider-middle').style.right =
        100 - percentage_to + '%';
    rangeSlider.querySelector('.range-slider-right').style.width =
        100 - percentage_to + '%';
}
